/* ARCHIVE — countdown + gallery + size select
   Reads dates from data-attributes rendered by Liquid (section settings /
   product metafields) rather than hard-coded JS values. */

function archiveInitCountdown(el){
  if(!el) return;
  const closeISO = el.dataset.close;
  if(!closeISO) return;
  const close = new Date(closeISO).getTime();
  const onExpireLabel = el.dataset.expiredLabel || "ARKIVERAD";

  function tick(){
    const diff = close - Date.now();
    if(diff <= 0){
      el.innerHTML = `<div class="countdown-label mono">${onExpireLabel}</div>`;
      clearInterval(timer);
      document.querySelectorAll("[data-live-tag]").forEach(function(tag){
        tag.innerHTML = onExpireLabel;
      });
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff / 3600000) % 24);
    const m = Math.floor((diff / 60000) % 60);
    el.querySelectorAll('[data-unit="d"]').forEach(n => n.textContent = String(d).padStart(2,"0"));
    el.querySelectorAll('[data-unit="h"]').forEach(n => n.textContent = String(h).padStart(2,"0"));
    el.querySelectorAll('[data-unit="m"]').forEach(n => n.textContent = String(m).padStart(2,"0"));
  }
  tick();
  const timer = setInterval(tick, 30000);
}

document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll("[data-countdown]").forEach(archiveInitCountdown);

  // Product gallery thumbnail swap
  document.querySelectorAll(".gallery-thumbs").forEach(function(rail){
    const main = document.querySelector(rail.dataset.mainTarget);
    rail.querySelectorAll(".gallery-thumb").forEach(function(thumb){
      thumb.addEventListener("click", function(){
        rail.querySelectorAll(".gallery-thumb").forEach(t => t.classList.remove("active"));
        thumb.classList.add("active");
        if(main){
          const img = thumb.querySelector("img");
          const mainImg = main.querySelector("img");
          if(img && mainImg) mainImg.src = img.src;
        }
      });
    });
  });
});
